import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';

import { ButtonModule } from '@plugins/client/button/legacy-button';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { ClearInputTranslationModule } from './translation-loader';

@Component({
  selector: 'plugins-clear-input',
  imports: [
    ClearInputTranslationModule,
    ButtonModule,
    CancelIconComponent,
    TranslatePipe,
  ],
  templateUrl: './clear-input.component.html',
  styleUrl: './clear-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearInputComponent {
  @Input() label?: string;
  readonly clear = output();
}
